<template>
	<v-layout row v-if="contestId && !dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<choose-funding
				:contest-id="contestId"
				v-model="old"
				:readonly="true"
			></choose-funding>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-funding
				:contest-id="contestId"
				v-model="current"
				:readonly="true"
			></choose-funding>
		</v-flex>
	</v-layout>
</template>

<script>
	import ChooseFunding from "../components/ChooseFunding";
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";

	export default {
		name: "CompareCountriesFundings",
		components: {NewVersionMarker, OldVersionMarker, ChooseFunding},

		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {}
		}
	};
</script>

<style scoped>

</style>
